'use strict';

var GridToolbarFaresClassUsageDirective = function GridToolbarFaresClassUsageDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-fares-class-usage.html')
  };
};
GridToolbarFaresClassUsageDirective.$inject = [];
module.exports = GridToolbarFaresClassUsageDirective;